import { api } from './client'

export interface ChildSummary {
  studentId: string
  fullName: string
  className: string | null
  gradeLevel: number | null
  relationship: string
  avgGrade: number | null
  gradesCount: number
  attendancePercent: number | null
}

export interface GradeView {
  id: string
  date: string
  value: string
  subjectName: string | null
  type: string
  comment: string | null
}

export interface AttendanceView {
  id: string
  date: string
  mark: string
  reason: string | null
}

export interface ParentInviteResponse {
  token: string
  expiresAt: number
  studentName: string
}

export const parentApi = {
  // Учитель: создать invite для родителя
  createInvite: (studentId: string, relationship: string = 'parent') =>
    api<ParentInviteResponse>('/parent-invites', {
      method: 'POST',
      body: JSON.stringify({ studentId, relationship }),
    }),

  // Parent: список своих детей
  myChildren: () => api<ChildSummary[]>('/parent/me/children'),

  childGrades: (studentId: string) => api<GradeView[]>(`/parent/students/${studentId}/grades`),

  childAttendance: (studentId: string) => api<AttendanceView[]>(`/parent/students/${studentId}/attendance`),
}
